module.exports = __webpack_public_path__ + "static/media/step3.4a63f771.svg";